import { Form, Space, message, Select, DatePicker, Segmented, Button } from "antd";
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from "react";
import { storageGet } from "../../../services/storage";
import http from "../../../services/http";
import dayjs from "dayjs";
import { useSearchParams } from "react-router-dom";
import { ReloadOutlined } from "@ant-design/icons";

const rulesValidation = {
  required: [{ required: true, message: "" }],
};

const options_visualizacao = [
  { label: "Planos Ação", value: 1 },
  { label: "Ações", value: 2 },
];

const options_status = [
  {
    value: 999,
    label: "Todos",
  },
  {
    value: -1,
    label: "Aguardando",
  },
  {
    value: 0,
    label: "Cancelado",
  },
  {
    value: 1,
    label: "Alcançado",
  },
  {
    value: 2,
    label: "Alcançado parcial",
  },
  {
    value: 3,
    label: "Em andamento",
  },
  {
    value: 4,
    label: "Não alcançado",
  },
];

const default_values_filter = {
  status: 2,
  status_acoes: 999,
  exibir: 999,
  visualizacao: 1,
  apontador: false,
  minhas_acoes: false,
  id_sistemas_origens: 999,
  data_inicio: dayjs().subtract(12, "month"),
  data_fim: dayjs(),
};

const options_exibir = [
  {
    value: 1,
    label: "Ações para mim",
  },
  {
    value: 2,
    label: "Somente apontamentos",
  },
  {
    value: 999,
    label: "Todos",
  },
];

const options_status_actions = [
  {
    value: 999,
    label: "Todos",
  },
  {
    value: -1,
    label: "Não aceito para realização",
  },
  {
    value: 0,
    label: "Não alcançado",
  },
  {
    value: 1,
    label: "Alcançado",
  },
  {
    value: 2,
    label: "Aceito para realização",
  },
  {
    value: 3,
    label: "Aguardando Avaliação",
  },
];

const ProblemasTableFormFilter = forwardRef(({ onFinish, loading, option_exibir = false, name }, ref) => {
  const [form] = Form.useForm();
  const [sistemasOrigem, setSistemasOrigem] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const modo_visualizacao = searchParams.get(name) ?? 1;
  const tab = searchParams.get("tab") ?? 1;

  useEffect(() => {
    setDefaultFilters(tab);
  }, [tab]);

  useEffect(() => {
    listarSistemasOrigem();
  }, []);

  const setDefaultFilters = useCallback((tab) => {
    let storageName = "f_mpda";
    if (tab == 2) {
      storageName = "f_apda";
    } else if (tab == 3) {
      storageName = "f_rpda";
    }
    const filtro_storage = JSON.parse(storageGet(storageName));
    form.setFieldsValue(
      filtro_storage
        ? {
            ...filtro_storage,
            visualizacao: 1,
            data_inicio: dayjs(filtro_storage?.data_inicio),
            data_fim: default_values_filter?.data_fim,
          }
        : default_values_filter
    );
  }, []);

  useImperativeHandle(ref, () => ({
    submitForm: () => {
      form.submit();
    },
  }));

  const listarSistemasOrigem = async () => {
    const api = await http("get", `v1/problemas_sistemas_origens/listar_ativos`, []);
    if (api.statusCode === 200) {
      const response = api?.response?.data ?? [];
      let array_options = [{ value: 999, label: "Todos" }];
      for (const el of response) {
        array_options.push({
          value: el.id,
          label: el.descricao,
        });
      }
      setSistemasOrigem(array_options);
    } else {
      message.error(api.response.message);
    }
  };

  return (
    <Form form={form} onFinish={onFinish} autoComplete="off">
      <Space wrap className="pda-form-filter">
        <Space direction="vertical" size={0}>
          <label className="filter-label">Modo visualização:</label>
          <Segmented
            disabled={loading}
            value={Number(modo_visualizacao)}
            onChange={(val) =>
              setSearchParams((state) => {
                state.set(name, val);
                return state;
              })
            }
            options={options_visualizacao}
          />
        </Space>

        <Space direction="vertical" size={0}>
          <label className="filter-label">Grupo Origem:</label>
          <Form.Item className="form-item-filter" name="id_sistemas_origens" rules={rulesValidation.required}>
            <Select
              disabled={loading}
              onChange={() => form.submit()}
              placeholder="Selecione o sistema"
              className="select-pda-form-filter"
              options={sistemasOrigem}
            />
          </Form.Item>
        </Space>

        <Space direction="vertical" size={0}>
          <label className="filter-label">Status:</label>
          <Form.Item className="form-item-filter" name="status" rules={rulesValidation.required}>
            <Select
              disabled={loading}
              onChange={() => form.submit()}
              placeholder="Selecione o status"
              className="select-pda-form-filter"
              options={options_status}
            />
          </Form.Item>
        </Space>

        <Space direction="vertical" size={0}>
          <label className="filter-label">Período:</label>
          <Space wrap>
            <Form.Item className="form-item-filter" name="data_inicio" rules={rulesValidation.required}>
              <DatePicker onChange={() => form.submit()} format={"DD/MM/YYYY"} disabled={loading} />
            </Form.Item>

            <Form.Item className="form-item-filter" name="data_fim" rules={rulesValidation.required}>
              <DatePicker onChange={() => form.submit()} format={"DD/MM/YYYY"} disabled={loading} />
            </Form.Item>
          </Space>
        </Space>

        <Space direction="vertical" size={0}>
          <label className="filter-label">Status Ações:</label>
          <Form.Item className="form-item-filter" name="status_acoes" rules={rulesValidation.required}>
            <Select
              disabled={loading}
              onChange={() => form.submit()}
              placeholder="Selecione o status"
              className="select-pda-form-filter"
              options={options_status_actions}
            />
          </Form.Item>
        </Space>

        {option_exibir && (
          <Space direction="vertical" size={0}>
            <label className="filter-label">Exibir:</label>
            <Form.Item className="form-item-filter" name="exibir">
              <Select
                disabled={loading}
                onChange={() => form.submit()}
                placeholder="Selecione uma opção"
                className="select-pda-form-filter"
                options={options_exibir}
              />
            </Form.Item>
          </Space>
        )}

        <Space direction="vertical" size={0}>
          <Form.Item className="form-item-filter" name="exibir">
            <Button title="Recarregar" disabled={loading} htmlType="submit" type="link" icon={<ReloadOutlined />} />
          </Form.Item>
        </Space>
      </Space>
    </Form>
  );
});

export { ProblemasTableFormFilter };
